/**
 * PublishTariffsUseCase
 *
 * Use case for publishing tariffs to the OCPI network.
 * Triggers tariff data sync and returns result status.
 */

import type { OcpiAdminRepository } from '../data/ocpi-admin-repository';
import type { PublishTariffsResult } from '../types/connection-status-types';
import { createPublishTariffsResult } from '../types/connection-status-types';

export class PublishTariffsUseCase {
  constructor(private readonly repository: OcpiAdminRepository) {}

  /**
   * Execute publish tariffs operation
   *
   * @param operatorId - Nayax operator ID
   * @returns PublishTariffsResult with success/failure details
   */
  async execute(operatorId: number): Promise<PublishTariffsResult> {
    const response = await this.repository.publishTariffs(operatorId);
    if (!response) throw new Error('The server returned an empty response.');
    return createPublishTariffsResult(response);
  }
}
